import React, { useContext } from "react";
import moment from "moment";

import Config from "@skin_config";
import { PreferencesContext } from "@common/contexts/preferences";
import { useTranslation } from "@common/hooks/translation";
import OddConverter from "@common/helpers/oddConverter";

const TicketDetailsCasinoSelection = ({ data }) => {
  const t = useTranslation();
  const [{ oddsFormat }] = useContext(PreferencesContext);
  const drawDate = data.drawDate && moment(data.drawDate);

  return (
    <div className="ticket-nested-section">
      {data.originalStatusName && (
        <div className="ticket-info-row">
          <p className="ticket-info-white">{data.originalStatusName}</p>
        </div>
      )}

      {drawDate?.year() !== 1 && (
        <div className="ticket-info-row">
          <p>{moment(drawDate).format("YYYY-MM-DD HH:mm:ss")}</p>
        </div>
      )}

      {data.marketName && (
        <div className="ticket-info-row">
          <p>{t(data.marketName)}</p>

          <p className="ticket-info-white">{OddConverter(Config, data.price, oddsFormat)}</p>
        </div>
      )}

      {data.numbers && (
        <div className="ticket-info-row">
          <p>{t("Selection")}</p>
          <span >{data.numbers.join(", ") || "-"}</span>
        </div>
      )}
      {data.winNumbers && (
        <div className="ticket-info-row">
          <p>{t("Event result")}</p>
          <div className='result-values'>
            {
              data.winNumbers.map((winNumber, index) => (
                <span key={winNumber} className={[data.numbers || []].includes(winNumber) ? 'static-green' : ''}>{winNumber}{index === data.winNumbers.length - 1 ? '' : ', '}</span>
              ))
            }
          </div>
        </div>
      )}
      {!!data.jackpotWin && (
        <div className="ticket-info-row">
          <div className="ticket-info-row-left-info">
            <i className="global-icon icon-jackpot" />
            <p className="ticket-info-row-label">{data.jackpotName}</p>
          </div>
          <p className="win-amount">{data.jackpotWin}</p>
        </div>
      )}
    </div>
  );
};

export default TicketDetailsCasinoSelection;
